import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as subscriptionActions } from '../../actions/subscriptionActions';
import { actions as debugActions } from '../../actions/debugActions';
import * as types from '../../constants/actionTypes';
import SubscriptionAdminNav from './SubscriptionAdminNav';
import Area from './Identifiers/locationArea';
import Brand from './Identifiers/locationBrand';
import Continent from './Identifiers/locationContinent';
import ManagementCompany from './Identifiers/locationMgmtCompany';
import Region from './Identifiers/locationRegion';
import Type from './Identifiers/locationType';
import JobTitle from './Identifiers/taskBaselineJobTitle';
import Community from './Identifiers/taskCommunity';
import Department from './Identifiers/taskDepartment';
import Discipline from './Identifiers/taskDiscipline';
import Status from './Identifiers/taskStatus';
import Phase from './Identifiers/taskPhase';
import ProjectManager from './Identifiers/locationProjectManager';
import Baselines from './Admin/BaselinesPage';
import Projects from './Admin/ProjectsPage';
import Support from './Admin/SupportPage';
import SubscriptionUsersPage from './SubscriptionUsersPage';
import UserRequests from './Admin/UserRequestsPage';
import SubscriptionProfile from './Admin/SubscriptionProfile/SubscriptionProfilePage';
import BaselineFilesPage from './Admin/BaselineFilesPage';
import Notification from '../Common/Notification';
import LocationsListPage from '../Locations/LocationsListPage';
import DocumentTitle from 'react-document-title';
import URLSearchParams from '@ungap/url-search-params'; // URLSearchParams polyfill for IE11
import UserTags from './Identifiers/userTags';
import LocationTags from './Identifiers/locationTag';
import TaskTags from './Identifiers/taskTags';
import ProjectTags from './Identifiers/projectTag';
import Routes from '../../constants/routes';
import './SubscriptionAdminPage.scss';

export class SubscriptionAdminPage extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            activeIdentifierName: null,
            activeSectionName: null,
            drawerOpen: false,
            editId: null,
            isProjectWidgetActive: false,
            subscriptionName: null,
            versionNumber: "",
            environment: "",
        };

    }

    async componentDidMount() {
        this.setRouteFromUrlParam();
        this.getDebugSettings();

        // if there is a section passed in then set it so it'll load initially
        let identifier = (this.props.initialSection) ? this.props.initialSection.toLowerCase() : "";
        this.setState({ activeIdentifierName: identifier });

        try {
            this.setState({ isFetching: true });
            const result = await this.props.subscriptionActions.getSubscriptionProfile();
            const payload = result.payload;
            if (result.type === types.GET_SUBSCRIPTION_PROFILE_SUCCESS) {
                this.setState(
                    {
                        isProjectWidgetActive: payload.subscriptionProfile.isProjectWidgetActive,
                        subscriptionName: payload.subscriptionProfile.name
                    }
                );
            } else if (result.type === types.GET_SUBSCRIPTION_PROFILE_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isFetching: false });
        }
    }

    setRouteFromUrlParam = () => {
        const urlParams = new URLSearchParams(this.props.location.search);

        if (urlParams.has('r')) {
            const routeParam = urlParams.get('r');

            this.setState({
                ...this.state,
                activeIdentifierName: routeParam
            });
        }
    }

    changeIdentifier = (title, newIdentifierName) => {
        this.setState({ activeIdentifierName: newIdentifierName.toLowerCase(), activeSectionName: title });
        this.props.history.push(Routes.AdminHome + '/' + newIdentifierName.toLowerCase());
    }

    closeActiveContainer = () => {
        this.setState({ activeIdentifierName: null });
    }

    getDebugSettings = async () => {
        try {
            const response = await this.props.debugActions.getDebugSettings();
            if (response.type === types.GET_DEBUG_SETTINGS_SUCCESS) {
                const payload = response.payload;
                this.setState({
                    versionNumber: payload.versionNumber,
                    environment: payload.environment
                });
            } else if (response.type === types.GET_DEBUG_SETTINGS_FAILURE) {
                Notification("error", "Error", response.payload.message);
                this.setState({ isLoading: false });
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
            this.setState({ isLoading: false });
        }
    }

    renderPage = () => {
        if (this.state.activeIdentifierName === null) {
            return "";
        }
        switch (this.state.activeIdentifierName.toLowerCase()) {
            case "baselines":
                return <Baselines subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "locations":
                return <LocationsListPage isSubPage={true} subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />;
            case "projects":
                return <Projects subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "support":
                return <Support subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "subscription_profile":
                return <SubscriptionProfile subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "users":
                return <SubscriptionUsersPage isSubPage={true} subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "user_requests":
                return <UserRequests subscriptionId={this.props.subscriptionId.toString()} onClose={this.closeActiveContainer} />
            case "area":
                return <Area subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "brand":
                return <Brand subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "continent":
                return <Continent subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "management_company":
                return <ManagementCompany subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "project_implementation_manager":
                return <ProjectManager subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "region":
                return <Region subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "type":
                return <Type subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "baseline_job_titles":
                return <JobTitle subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "community":
                return <Community subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "department":
                return <Department subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "discipline":
                return <Discipline subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "status":
                return <Status subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "phase":
                return <Phase subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "baseline_files":
                return <BaselineFilesPage subscriptionId={this.props.subscriptionId.toString()} onClose={this.closeActiveContainer} />
            case "tags":
                if (this.state.activeSectionName == "Task Config") {
                    return <TaskTags subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
                } else if (this.state.activeSectionName === "Location Config") {
                    return <LocationTags subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
                }
                break;
            case "user_tags":
                return <UserTags subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            case "project_tags":
                return <ProjectTags subscriptionId={this.props.subscriptionId} onClose={this.closeActiveContainer} />
            default:
                return "";
        }
    }

    render() {

        // on mobile we only show either the list or the container
        const isListActive = (this.state.activeIdentifierName) ? '' : ' active';
        const isContainerActive = (!this.state.activeIdentifierName) ? '' : ' active';

        return (
            <div className="admin-settings-page">
                <DocumentTitle title="Admin" />
                <div className={'identifier-list' + isListActive}>
                    <SubscriptionAdminNav
                        onClick={this.changeIdentifier}
                        activeItemName={this.state.activeIdentifierName}
                        activeSectionName={this.state.activeSectionName}
                        userRole={this.props.userRole}
                        isProjectWidgetActive={this.state.isProjectWidgetActive}
                        versionNumber={this.state.versionNumber}
                        environment={this.state.environment}
                        user={this.props.user}
                        subscriptionName={this.state.subscriptionName} />
                </div>
                <div className={'identifier-container' + isContainerActive}>
                    {this.renderPage()}
                </div>
            </div>
        );
    }

}
SubscriptionAdminPage.propTypes = {
    subscriptionId: PropTypes.number.isRequired,
    userRole: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
    subscriptionActions: PropTypes.object.isRequired,
    debugActions: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    initialSection: PropTypes.string
};

function mapStateToProps(state, ownProps) {
    let section = null;

    if (ownProps.match.params.section) {
        section = ownProps.match.params.section;
    }
    return {
        subscriptionId: state.user.currentSubscriptionId,
        userRole: state.user.customerRole,
        user: state.user,
        history: ownProps.history,
        initialSection: section
    };
}

function mapDispatchToProps(dispatch) {
    return {
        subscriptionActions: bindActionCreators(subscriptionActions, dispatch),
        debugActions: bindActionCreators(debugActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionAdminPage);

